import { IteroPaymentType } from 'components/ITeroOrderPayment';
import { useQuery } from 'react-query';
import { iteroCheckoutService } from 'services';
import { ScannerFundingSource, ScannerSubFundingSource } from 'types';
import { ServerStateKeysEnum } from '../../constants';

export const useIteroPayments = (
  paymentType: IteroPaymentType,
  tmSelectedScannerFundingSource: ScannerFundingSource,
  tmSelectedScannerSubFundingSource?: ScannerSubFundingSource,
  financingCompany?: string
) => {
  return useQuery(
    `${ServerStateKeysEnum.iteroPaymentMethod}-${paymentType}`,
    () => {
      return iteroCheckoutService.getDoctorPaymentOptions(
        paymentType,
        tmSelectedScannerFundingSource,
        tmSelectedScannerSubFundingSource,
        financingCompany
      );
    },
    { staleTime: 0, cacheTime: 0, refetchOnWindowFocus: 'always' }
  );
};
